import { userConstants } from '../reducers/auth'
import { history } from '../../helpers'
import { AppDispatch } from '../store'
import { User } from '../../api/model/User'
import { IccUserApi } from '../../api/api/IccUserApi'
import { userService } from '../user/userService'

function updateUser(user: User) {
  return {
    type: userConstants.USER_MODIFIED,
    user,
  }
}

function attemptLogin(username: string, password: string, target?: string): (dispatch: AppDispatch) => Promise<void> {
  function loginRequest(username: string) {
    return {
      type: userConstants.LOGIN_REQUEST,
      username,
    }
  }

  function loginSuccess(user: User) {
    return {
      type: userConstants.LOGIN_SUCCESS,
      user: user,
    }
  }

  function loginFailure(username: string) {
    return {
      type: userConstants.LOGIN_FAILURE,
      username,
    }
  }

  return (dispatch: AppDispatch) => {
    dispatch(loginRequest(username))
    return userService
      .attemptLogin(username, password)
      .then(async ({ user }) => {
        dispatch(loginSuccess(user))

        if (target) {
          history.push(target)
        }
      })
      .catch((error) => {
        console.log('user.error-while-logging-in')
        dispatch(loginFailure(error.toString()))
        throw error
      })
  }
}

function logout(userApi: IccUserApi): { type: string } {
  userService.logout(userApi)
  return {
    type: userConstants.LOGOUT,
  }
}

export const authActions = {
  attemptLogin,
  updateUser,
  logout,
}
